export default [
  {
    path: '/api/process/assy',
    name: 'AssemblyHistoryList',
    meta: {
      pageTitle: '조립공정',
      title: '조립이력',
      authRequired: true,
    },
    component: () => import('@/views/process/assemblyHistory')
  },

  {
    path: '/api/process/assyItem',
    name: 'AssemblyItemHistoryList',
    meta: {
      pageTitle: '조립공정',
      title: '항목별 조립이력',
      authRequired: true,
    },
    component: () => import('@/views/process/assemblyItemHistory')
  },
  
  {
    path: '/api/process/assyNg',
    name: 'AssemblyNgHistoryList',
    meta: {
      pageTitle: '조립공정',
      title: '조립 NG이력',
      authRequired: true,
    },
    component: () => import('@/views/process/assemblyNgHistory')
  },
  {
    path: '/api/process/insp',
    name: 'InspectionHistoryList',
    meta: {
      pageTitle: '검사공정',
      title: '검사이력',
      authRequired: true,
    },
    component: () => import('@/views/process/inspectionHistory')
  },  
    {
    path: '/api/process/inspItem',
    name: 'InspectionItemHistoryList',
    meta: {
      pageTitle: '검사공정',
      title: '항목별 검사이력',
      authRequired: true,
    },
    component: () => import('@/views/process/inspectionItemHistory')
  },  
  {
    path: '/api/process/inspNg',
    name: 'InspectionNgHistoryList',
    meta: {
      pageTitle: '검사공정',
      title: '검사 NG이력',
      authRequired: true,
    },
    component: () => import('@/views/process/inspectionNgHistory')
  },
  {
    path: '/api/process/trans',
    name: 'EngineSupplyRequestList',
    meta: {
      pageTitle: '이송공정',
      title: '엔진보급요청',
      authRequired: true,
    },
    component: () => import('@/views/process/engineSupplyRequest')
  }, 
  {
    path: '/api/process/engines',
    name: 'EngineInventoryList',
    meta: {
      pageTitle: '이송공정',
      title: '엔진별 현황',
      authRequired: true,
    },
    component: () => import('@/views/process/engineInventory')
  },  
  {
    path: '/api/process/warehouse',
    name: 'EngineStausList',
    meta: {
      pageTitle: '이송공정',
      title: '엔진자동창고 현황',
      authRequired: true,
    },
    component: () => import('@/views/process/warehouseStatus')
  },  

]
